import { render, staticRenderFns } from "./PromocoesHotelEditar.vue?vue&type=template&id=cc16de7a&scoped=true&"
import script from "./PromocoesHotelEditar.vue?vue&type=script&lang=js&"
export * from "./PromocoesHotelEditar.vue?vue&type=script&lang=js&"
import style0 from "./PromocoesHotelEditar.vue?vue&type=style&index=0&id=cc16de7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc16de7a",
  null
  
)

export default component.exports